module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_7005.3514c043.png";